import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { fretboardConfigs } from "../../lib/fretboards";
import metaActions from "../../state/meta/actions";
import store from "../../store";

class BoardSelector extends PureComponent {
	static propTypes = {
		selectedFretboardConfig: PropTypes.number
	};

	setFretboardConfig(fretboardConfig) {
		store.dispatch(metaActions.update({ fretboardConfig, highlight: null }));
	}

	handleSelection = (evt) => {
		this.setFretboardConfig(parseInt(evt.target.value));
	}

	render() {
		let { selectedFretboardConfig = 0 } = this.props;

		return (
			<select
				defaultValue={selectedFretboardConfig}
				onChange={this.handleSelection}>
				{ fretboardConfigs.map(({ title }, index) => (
					<option value={index} key={index}>{ title }</option>
				)) }
			</select>
		);
	}
}

export default BoardSelector;
